export default "__VITE_ASSET__7VtqallN__"